import { BaseTooltip, BaseTooltipContent } from 'root/src/client/v2/common/components/BaseTooltip/BaseTooltip';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
export function ChatAutoShareHeader() {
    return (<div className="flex items-center gap-2">
			<span className="text-sm font-bold uppercase tracking-wide">
				Chat Auto-Share
			</span>
			<span className="text-[10px] font-bold uppercase bg-primary text-white px-1.5 py-0.5 rounded-full leading-none">
				New
			</span>
			<BaseTooltip tooltip={(<BaseTooltipContent className="max-w-60">
						When enabled, Dare Drop will automatically post your sharing link
						as a chat announcement every 20 minutes while you are live
						and streaming the sponsored game. You can disable this at any time.
					</BaseTooltipContent>)}>
				<InfoOutlineIcon className="!fill-white !text-xl bg-primary rounded-full cursor-pointer"/>
			</BaseTooltip>
		</div>);
}
